import React from 'react';
import { Flex, useIsMobile } from '@amzn/storm-ui';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { StyledLink } from 'src/commons/components/StyledLink';

export const IA2AccountDropdownFooterLinks: React.VFC = () => {
  const isMobile = useIsMobile();
  const { currentEntityId } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();

  const managerAccountDiscoveryLink = `/am/managerAccounts/list?entityId=${currentEntityId}&ref_=AAC_unav_discovery_account_dropdown`;

  return (
    <Flex
      data-ccx-e2e-id="account-dropdown-footer-links"
      direction="column"
      rowGap="xxsmall"
      padding={isMobile ? 'xsmall' : 'small base'}
    >
      <StyledLink
        href={`/accounts?entityId=${currentEntityId}&ref_=AAC_unav_manageaccounts`}
        data-ccx-e2e-id="aac-account-management"
        {...getTaktAttributes('manager-account-link', chromeComponents.HEADER)}
      >
        {bundle.getMessage('account-dropdown-manage-accounts-link-label')}
      </StyledLink>
      <StyledLink
        href={managerAccountDiscoveryLink}
        data-ccx-e2e-id="aac-master-account-discovery-link"
        {...getTaktAttributes(
          'ccx-master-account-discovery-link',
          chromeComponents.HEADER,
        )}
      >
        {bundle.getMessage('account-dropdown-create-manager-account-label')}
      </StyledLink>
    </Flex>
  );
};
